import {
  CLEAR_FORM_STEP_ONE,
  CLOSE_QUOTE_SAVE_ERROR_DIALOG,
  CLOSE_QUOTE_SAVED_SATISFACTORY_DIALOG,
  GET_DISTRICTS,
  GET_DISTRICTS_ERROR,
  GET_DISTRICTS_SUCCESS,
  GET_INITIAL_VALUE_QUOTE,
  GET_INITIAL_VALUE_QUOTE_ERROR,
  GET_INITIAL_VALUE_QUOTE_SUCCESS,
  GET_QUOTE_BY_CODE,
  GET_QUOTE_BY_CODE_ERROR,
  GET_QUOTE_BY_CODE_SUCCESS,
  RESET_QUOTE_STEP_ONE_STATE,
  SAVE_QUOTE_STEP_ONE,
  SAVE_QUOTE_STEP_ONE_ERROR,
  SAVE_QUOTE_STEP_ONE_SUCCESS,
  SHOW_QUOTE_SAVE_ERROR_DIALOG,
  SHOW_QUOTE_SAVED_SATISFACTORY_DIALOG,
  BUDGET_TYPE_ERROR,
  ON_SECOND_CALL_AUTOMATIC,
  OFF_SECOND_CALL_AUTOMATIC
} from './QuoteStepOne.actions'

const quoteStepOneState = {
  detail: '',
  initData: {
    districts: [],
    error: false,
    exchangeRates: [],
    maxClosingDate: '',
    maxDays: 0,
    maxAmountsUTMs: 0,
    minAmountPesos: '',
    minDate: '',
    maxDate: undefined,
    serverDate: ''
  },
  secondCallAutomatic: true,
  loading: false,
  name: '',
  openSaveDialog: false,
  openSaveErrorDialog: false,
  quote: {},
  saving: false,
  errors: []
}

/**
 * The Quote Step One's reducer.
 */
const quoteStepOneSectionReducer = (state = quoteStepOneState, { payload, type }) => {
  switch (type) {
    case GET_DISTRICTS: {
      return { ...state, loading: true }
    }
    case GET_DISTRICTS_ERROR: {
      return { ...state, loading: false }
    }
    case GET_DISTRICTS_SUCCESS: {
      return { ...state, loading: false, initData: { ...state.initData, districts: payload.districts } }
    }

    case GET_INITIAL_VALUE_QUOTE: {
      return { ...state, initData: { ...state.initData, error: false }, loading: true }
    }
    case GET_INITIAL_VALUE_QUOTE_ERROR: {
      return { ...state, initData: { ...state.initData, error: true }, loading: false }
    }
    case GET_INITIAL_VALUE_QUOTE_SUCCESS: {
      return {
        ...state,
        loading: false,
        initData: {
          ...state.initData,
          error: false,
          exchangeRates: payload.exchangeRates,
          maxAmountsUTMs: payload.maxAmountsUTMs,
          maxClosingDate: payload.maxClosingDate,
          maxDays: payload.maxDays,
          minAmountPesos: payload.minAmountPesos,
          minDate: payload.minDate,
          maxDate: payload.maxDate,
          serverDate: payload.serverDate
        }
      }
    }
    case GET_QUOTE_BY_CODE: {
      return { ...state, loading: true }
    }
    case GET_QUOTE_BY_CODE_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case GET_QUOTE_BY_CODE_SUCCESS: {
      return {
        ...state,
        loading: false,
        quote: payload.quote,
        secondCallAutomatic: payload.quote.secondCallAutomatic
      }
    }
    case RESET_QUOTE_STEP_ONE_STATE: {
      return quoteStepOneState
    }
    case SAVE_QUOTE_STEP_ONE: {
      return { ...state, saving: true }
    }
    case SAVE_QUOTE_STEP_ONE_ERROR: {
      return {
        ...state,
        saving: false,
        errors: payload.error
      }
    }
    case SAVE_QUOTE_STEP_ONE_SUCCESS: {
      return {
        ...state,
        saving: false,
        errors: []
      }
    }
    case BUDGET_TYPE_ERROR: {
      return {
        ...state,
        saving: false,
        errors: payload.error
      }
    }
    case SHOW_QUOTE_SAVED_SATISFACTORY_DIALOG: {
      return { ...state, openSaveDialog: true }
    }
    case CLOSE_QUOTE_SAVED_SATISFACTORY_DIALOG: {
      return { ...state, openSaveDialog: false }
    }
    case SHOW_QUOTE_SAVE_ERROR_DIALOG: {
      return { ...state, openSaveErrorDialog: true }
    }
    case CLOSE_QUOTE_SAVE_ERROR_DIALOG: {
      return { ...state, openSaveErrorDialog: false }
    }
    case CLEAR_FORM_STEP_ONE: {
      return {
        ...quoteStepOneState,
        initData: {
          ...quoteStepOneState.initData
        }
      }
    }
    case ON_SECOND_CALL_AUTOMATIC: {
      return { ...state, secondCallAutomatic: true }
    }
    case OFF_SECOND_CALL_AUTOMATIC: {
      return { ...state, secondCallAutomatic: false }
    }
    default:
      return state
  }
}

export default quoteStepOneSectionReducer
